import React from "react";
import {
  Box,
  Select,
  Avatar,
  MenuItem,
  Typography,
  Chip,
  useTheme,
} from "@mui/material";
import { currencyMeta } from "../utils/currency";
import { useMedia } from "../context/MediaContext";
import { useMainStore } from "../store/store";

const ChoosingCurrency: React.FC = () => {
  const { curr, changeCurrency } = useMainStore();
  const { isMobile400 } = useMedia();
  const theme = useTheme();
  const active = currencyMeta[curr];

  return (
    <Select
      value={currencyMeta[curr] ? curr : ""}
      aria-label="Display currency"
      IconComponent={() => null}
      onChange={(e) => changeCurrency(e.target.value)}
      MenuProps={{ disableScrollLock: true }}
      sx={{
        minWidth: 40,
        cursor: "pointer",
        "& .MuiSelect-select": {
          padding: 0 + " !important",
          display: "flex",
          alignItems: "center",
          height: "50px",
        },
        "& .MuiOutlinedInput-input": {
          padding: 0 + " !important",
          display: "flex",
          alignItems: "center",
          height: "50px",
        },
        "& .MuiInputBase-input": {
          padding: 0 + " !important",
          display: "flex",
          alignItems: "center",
          height: "50px",
        },
        "& fieldset": { border: "none" },
      }}
      renderValue={() => (
        <Chip
          sx={{
            px: 0.5,
            height: "42px",
            minWidth: isMobile400 ? "52px" : "100px",
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
            "& .MuiChip-avatar": {
              width: "30px",
              height: "30px",
              marginRight: isMobile400 ? 0 : "8px",
            },
            "& .MuiChip-label": {
              fontSize: 14,
              fontWeight: 700,
              color: theme.palette.text.primary,
              display: isMobile400 ? "none" : "block",
            },
          }}
          avatar={active ? <Avatar src={active.img} alt="" /> : undefined}
          label={curr}
        />
      )}
    >
      {Object.entries(currencyMeta).map(([key, value]) => (
        <MenuItem key={key} value={key}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              width: "220px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
              <img
                src={value.img}
                alt=""
                width={26}
                height={26}
                style={{ objectFit: "contain", borderRadius: 6 }}
              />
              <Typography fontWeight={600}>{value.label}</Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" fontWeight={700}>
              {key}
            </Typography>
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
};

export default ChoosingCurrency;
